// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2eJl{width:100%;height:100vh;height:-webkit-fill-available;padding:7.2rem 0 6.5rem;text-align:center;background:#fff;position:fixed;display:flex;bottom:0;left:0;z-index:10;transform:translateY(100%);transition:transform .3s ease-in-out}@media (min-width:62em){._2eJl{display:none}}._3Ysb{transform:none;box-shadow:0 .4rem .8rem 0 rgba(0,0,0,.08)}.eOiQ{display:flex;flex-wrap:wrap}.Ffn7{display:flex;position:relative}._2zdq{width:100%;position:relative}._2wwb{width:100%;height:100%;overflow-y:scroll;-webkit-overflow-scrolling:touch;position:absolute}._6pNn{width:33.333%;margin:0 0 .8rem;padding:.8rem 1rem;position:relative}.YNWE{min-height:4.8rem;margin:1.2rem 0 0}._1Iqx{width:100%;max-width:160px;margin:0 auto;display:block}._1uAO{position:absolute;top:.6rem;right:.6rem}._3l-Y{width:100%;min-width:auto;min-height:0;margin:1.2rem 0 0;font-size:1.6rem;line-height:1.8rem;padding:.6rem}.JR6z{position:absolute;right:.8rem;bottom:-5.6rem}.JR6z svg{transform:rotate(-45deg);height:4.8rem}._10Y8{cursor:pointer}html[dir=rtl] ._1uAO{right:auto;left:.6rem}html[dir=rtl] .JR6z{right:auto;left:.8rem}", ""]);
// Exports
exports.locals = {
	"wrapp": "_2eJl",
	"wrapp__show": "_3Ysb",
	"productList": "eOiQ",
	"container": "Ffn7",
	"frame": "_2zdq",
	"productsWrapp": "_2wwb",
	"product": "_6pNn",
	"series": "YNWE",
	"productImg": "_1Iqx",
	"addBtnWrapp": "_1uAO",
	"btn": "_3l-Y",
	"closeWrapp": "JR6z",
	"closeIcon": "_10Y8"
};
module.exports = exports;
